import {
  CleanBeauty,
  CleanBeautyLabelSchema,
  CleanBeautyLabels,
  CleanBeautyResponse,
} from "./cleanBeautySchema";

interface ResponseError extends Error {
  status?: number;
}

type CleanBeautyInfo = {
  free_From: string[];
  labels: CleanBeautyLabels[];
};

function getCleanBeautyURL(ean: string, cleanBeautyBasePath: string) {
  return `${cleanBeautyBasePath}/json.php?id=634e65bc11ef5&ean=${ean}`;
}

const TIMEOUT_DURATION = 1500;

async function getCleanBeautyData(
  ean: string,
  cleanBeautyBasePath: string,
): Promise<CleanBeautyInfo> {
  try {
    const controller = new AbortController();
    const { signal } = controller;
    const id = setTimeout(() => controller.abort(), TIMEOUT_DURATION);
    const cleanBeautyUrl = getCleanBeautyURL(ean, cleanBeautyBasePath);
    const res = await fetch(cleanBeautyUrl, { signal });
    clearTimeout(id);
    if (!res.ok) {
      const error = new Error(res.statusText) as ResponseError;
      error.status = res.status;
      throw error;
    }
    const data: CleanBeauty = CleanBeautyResponse.parse(await res.json());
    const free_from: string[] = [],
      labels: CleanBeautyLabels[] = [];
    const currentData = data[ean];
    if (currentData?.available === 1) {
      for (const [free_from_label, value] of Object.entries(
        currentData.free_of,
      )) {
        if (value === 1) {
          free_from.push(free_from_label);
        }
      }
      for (const [label, value] of Object.entries(currentData.labels)) {
        const cblabel = CleanBeautyLabelSchema.parse(label);
        if (value === 1) {
          labels.push(cblabel);
        }
      }
    }

    return {
      free_From: free_from,
      labels,
    };
  } catch (e) {
    if (e as ResponseError) {
      throw e;
    }
    return {
      free_From: [],
      labels: [],
    };
  }
}

export type { CleanBeautyInfo };
export { getCleanBeautyData };
